import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ETLDataRecalculationObj } from '../../cxone-etl-recalculation/cxone-etl-data-recalculation/cxone-etl-data-recalculation.model';

@Component({
    selector: 'cv-manage-metrics-recalculation-details-modal',
    templateUrl: './manage-metrics-recalculation-details-modal.component.html',
    styleUrls: ['./manage-metrics-recalculation-details-modal.component.scss']
})
export class ManageMetricsRecalculationDetailsModalComponent implements OnInit {

    headerTitle: string;
    loading: boolean;
    @Input() data: ETLDataRecalculationObj;
    public selectedMetricName: string;
    public initiatedBy: string;
    public recalculateDate: string;
    public lastModifiedDate: string;
    public definition: string;
    public isRecalculationComplete = true;
    public modalDetails: string[];

    constructor(
        private dialogRef: DynamicDialogRef,
        private cvLocalizationService: CVLocalizationService,
        public _dialogConfig: DynamicDialogConfig
    ) { }

    async ngOnInit(): Promise<void> {
        await this.loadLocalization();
        this.selectedMetricName = this._dialogConfig.data.metricsName;
        this.modalDetails = this._dialogConfig.data.modalDetails;
        this.recalculateDate = this._dialogConfig.data.modalDetails.recalculationDate;
        this.initiatedBy = this._dialogConfig.data.modalDetails.initiatedBy;
        this.definition = this._dialogConfig.data.modalDetails.def;
        this.lastModifiedDate = this._dialogConfig.data.modalDetails.lastModified;
        this.isRecalculationComplete = this._dialogConfig.data.modalDetails.recalcComplete;
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('Manage_Metrics_Recalculation');
        }
        catch {
            console.error('Failed to load localization for Manage_Metrics_Recalculation');
        }
        finally {
            this.headerTitle = this.getLocalizationString("Recalculation_Details", "Recalculation Details");
        }
    }

    getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("Manage_Metrics_Recalculation", key, defaultValue);
        return baseString;
    }

    close(): void {
        this.dialogRef.close();
    }
}